import Vue from 'vue'
import router from '@router'
import store from '@state/store'
import '@src/filters/date.filters'
import '@src/filters/currency.filters'
import '@src/filters/text.filters'
import App from './app.vue'

import '@components/_globals'

import './design/reset.css'

Vue.config.productionTip = process.env.NODE_ENV === 'production'

if (process.env.VUE_APP_TEST === 'e2e') {
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')


if (process.env.VUE_APP_TEST === 'e2e') {
  window.__app__ = app
}
